import { IConfig } from './types';

const config: IConfig = {
  env: 'staging',
  productName: 'Quiz Master',
  productUrl: 'https://staging.quizmasterapp.in',
};

export default config;
